interface FocusIndicatorProps {
  x?: number; // Position in percentage (0-100)
  y?: number; // Position in percentage (0-100)
}

export function FocusIndicator({ x = 50, y = 50 }: FocusIndicatorProps) {
  return (
    <div
      style={{
        position: 'absolute',
        top: `${y}%`,
        left: `${x}%`,
        transform: 'translate(-50%, -50%)',
        width: '60px',
        height: '60px',
        pointerEvents: 'none',
        zIndex: 10,
      }}
    >
      {/* Outer square */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          border: '2px solid rgba(255, 204, 0, 0.9)',
          borderRadius: '4px',
          animation: 'focus-pulse 0.6s ease-out',
        }}
      />
      
      {/* Inner cross */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '0',
          right: '0',
          height: '1px',
          background: 'rgba(255, 204, 0, 0.7)',
          transform: 'translateY(-50%)',
        }}
      />
      <div
        style={{
          position: 'absolute',
          top: '0',
          bottom: '0',
          left: '50%',
          width: '1px',
          background: 'rgba(255, 204, 0, 0.7)',
          transform: 'translateX(-50%)',
        }}
      />
      
      {/* Center dot */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '4px',
          height: '4px',
          borderRadius: '50%',
          background: 'rgba(255, 204, 0, 0.9)',
          transform: 'translate(-50%, -50%)',
        }}
      />
      
      {/* Add animation keyframes via inline style tag */}
      <style>{`
        @keyframes focus-pulse {
          0% {
            transform: scale(1.5);
            opacity: 0;
          }
          50% {
            opacity: 1;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}
